var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"editPage"}},[_c('div',{staticClass:"flex flex-row mb-2.5"},[_c('SubHeader',{attrs:{"backButton":true,"backRedirectionUrl":"/case-dashboard","customCrumbLists":_vm.customBreadCrumbs}})],1),_c('div',{attrs:{"id":"dashboard_container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }